<template>
    <el-card>
        <el-tabs v-model="activeActivity" @tab-click="handleClick">
            <el-tab-pane v-loading="updating" label="Profil" name="profil">
                <el-form :model="user" :rules="rules">
                    <!--
                    <el-form-item v-if="!isAdmin" label="Rôle" prop="role">
                    -->
                    <el-form-item v-if="!isAdmin" label="Rôle" prop="role">
                        <el-select
                            v-model="user.role"
                            class="filter-item"
                            placeholder="role"
                        >
                            <el-option
                                v-for="item in roles"
                                :key="'rol' + item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="user.role === 'externe' && user.livraison_adresse_label">
                        <el-button
                            type="primary"
                            size="small"
                            icon="el-icon-message"
                            @click="opendialogNotification()"
                        >
                            le rendre allocataire + notifier par email
                        </el-button>
                    </el-form-item>
                    <span v-if="user.role === 'externe' && !user.livraison_adresse_label">
                        utilisateur sans adresse, il ne peut devenir Allocataire
                    </span>
                    <h3 v-if="isAdmin">Administrateur DPR</h3>
                    <el-form-item
                        label="Nom"
                        prop="name"
                        :error="getErrorForField('name', errors)"
                    >
                        <!--
                        <el-input v-model="user.name" :disabled="isAdmin" />
                        -->
                        <el-input v-model="user.name" />
                    </el-form-item>
                    <el-form-item
                        label="Prénom"
                        prop="prenom"
                        :error="getErrorForField('prenom', errors)"
                    >
                        <!--
                        <el-input v-model="user.prenom" :disabled="isAdmin" />
                        -->
                        <el-input v-model="user.prenom" />
                    </el-form-item>
                    <el-form-item label="Email" prop="email">
                        <el-input v-model="user.email" :disabled="isAdmin" />
                    </el-form-item>
                    <el-form-item label="Tél." prop="telfix">
                        <el-input v-model="user.telfix" :disabled="isAdmin" />
                    </el-form-item>
                    <el-form-item>
                        <!--
                        <el-button
                            type="primary"
                            :disabled="user.role === 'admin'"
                            @click="onSubmit"
                        >
                        -->
                        <el-button type="primary" @click="onSubmit">
                            Enregistrer
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane v-loading="updating" label="Adresses" name="adresses">
                <el-form>
                    <el-form-item label="Adresse de livraison" prop="adresse">
                        <div
                            class="el-input as-el-input"
                            v-html="user.livraison_adresse_label"
                        />
                        <div class="controls">
                            <el-button
                                v-if="!user.livraison_adresse_id"
                                type="success"
                                icon="el-icon-plus"
                                @click="editAdresse('livraison_adresse')"
                            >
                                ajouter une adresse
                            </el-button>
                            <el-link
                                v-if="user.livraison_adresse_id"
                                type="primary"
                                icon="el-icon-edit"
                                :underline="false"
                                @click="editAdresse('livraison_adresse')"
                            />
                            <el-link
                                v-if="user.livraison_adresse_id"
                                type="danger"
                                icon="el-icon-circle-close"
                                :underline="false"
                                @click="delAdresse('livraison_adresse')"
                            />
                        </div>
                    </el-form-item>
                    <el-form-item label="Adresse de facturation" prop="adresse">
                        <el-switch
                            v-model="commeLivraison"
                            :active-text="'comme livraison'"
                        />
                        <template v-if="!commeLivraison">
                            <div
                                class="el-input as-el-input"
                                v-html="user.facturation_adresse_label"
                            />
                            <div class="controls">
                                <el-button
                                    v-if="!user.facturation_adresse_id"
                                    type="success"
                                    icon="el-icon-plus"
                                    @click="editAdresse('facturation_adresse')"
                                >
                                    ajouter une adresse
                                </el-button>
                                <el-link
                                    v-if="user.facturation_adresse_id"
                                    type="primary"
                                    icon="el-icon-edit"
                                    :underline="false"
                                    @click="editAdresse('facturation_adresse')"
                                />
                                <el-link
                                    v-if="user.facturation_adresse_id"
                                    type="danger"
                                    icon="el-icon-circle-close"
                                    :underline="false"
                                    @click="delAdresse('facturation_adresse')"
                                />
                            </div>
                        </template>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="Allocations" name="allocations">
                <panier
                    v-if="user.id && user.role != 'externe'"
                    :userid="user.id"
                    :parent="this"
                />
            </el-tab-pane>
        </el-tabs>
        <adresses
            :isvisible="dialogAdressesVisible"
            :adresse_id="active_adresse_id"
            :column_adresse="active_column_adresse"
            :parent="this"
        />
        <el-dialog
            title="Notification"
            :visible.sync="dialogNotification"
            :modal-append-to-body="true"
            :append-to-body="true"
            v-loading="notificationLoading"
        >
            <div class="form-container">
                Voulez-vous envoyer un email à {{ this.user.prenom }} {{ this.user.name }}
                notifiant qu'il devient allocataire et l’invitant à initialiser son mot de passe?
                <hr />
                <el-form ref="invitationForm" style="max-width: 600px;">
                    <el-form-item label="Message" prop="message">
                        <el-input type="textarea" :rows="8" v-model="message" />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogNotification = false">
                        Annuler
                    </el-button>
                    <el-button
                        type="primary"
                        @click="handleNotifierUserAllocataire()"
                    >
                        Envoyer
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
import Resource from "@/api/resource";
import Adresses from "@/components/Adresses";
import Panier from "@/components/Panier";
const userResource = new Resource("users");
import { findoptions } from "@/utils/options";


export default {
    props: {
        user: {
            type: Object,
            default: () => {
                return {
                    name: "",
                    email: "",
                    avatar: "",
                    role: "",
                    roles: []
                };
            }
        }
    },
    components: {
        Adresses,
        Panier
    },
    data() {
        return {
            rules: {
                name: {},
                prenom: {}
            },
            activeActivity: "allocations",
            updating: false,
            roles: [
                // { value: "admin", label: "Administrateur DPR" },
                { value: "allocataire", label: "Allocataire" },
                { value: "externe", label: "Liste attente" }
            ],
            errors: [],
            dialogAdressesVisible: false,
            notificationLoading: false,
            active_column_adresse: null,
            active_adresse_id: null,
            commeLivraison: false,
            dialogNotification: false,
            message: "",
            options: {
                mail_notif_allocataire: ""
            },
        };
    },
    watch: {
        commeLivraison(val) {
            if (val && this.user && this.user.facturation_adresse_id) {
                this.delAdresse("facturation_adresse");
            }
        },
        user(val) {
            if (
                val &&
                val.id &&
                (val.livraison_adresse_id == val.facturation_adresse_id ||
                    !val.facturation_adresse_id)
            ) {
                this.commeLivraison = true;
            }
        }
    },
    created() {
        this.dialogAdressesVisible = false;
        // console.log("this.$route.hash");
        // console.log(this.$route.hash);
        if (this.$route.hash) {
            this.activeActivity = this.$route.hash.replace("#", "");
        }
        findoptions(this.options, this, true);
    },
    activated() {
        // console.log("USER DATA activated");
    },
    computed: {
        isAdmin() {
            if (this.user && this.user.roles) {
                var f = this.user.roles.find(role => role === "admin");
                if (f !== undefined) {
                    return true;
                }
            }
            return false;
        }
    },
    methods: {
        callbackoptions(slug, data) {
            this.options[slug] = data;
        },
        opendialogNotification(){
            this.dialogNotification = true;
            this.message = this.options["mail_notif_allocataire"];
        },
        handleNotifierUserAllocataire() {
            this.user.role = "allocataire";
            this.user.notification = "externe2allocataire";
            this.user.message = this.message;
            this.onSubmit();
        },
        handleClick(tab, event) {
            console.log("Switching tab ", tab, event);
        },
        onSubmit() {
            this.errors = [];
            this.updating = true;
            // console.log(this.user);
            userResource
                .update(this.user.id, this.user)
                // .then(response => {
                .then(() => {
                    console.log("ok");
                    this.updating = false;
                    var notification = this.user.notification
                        ? " et notifié"
                        : "";
                    this.$message({
                        message: "Utilisateur mis à jour" + notification,
                        type: "success",
                        duration: 5 * 1000
                    });
                    this.user.notification = 0;
                    this.dialogNotification = false;
                })
                .catch(error => {
                    if (error.response && error.response.data) {
                        this.errors = error.response.data.errors;
                    }
                    this.updating = false;
                    this.user.notification = 0;
                    this.dialogNotification = false;
                    location.reload();
                });
        },
        callbackAdresse(adresse_id, adresse_label, column_adresse) {
            this.user[column_adresse + "_label"] = adresse_label;
            if (this.user[column_adresse + "_id"] != adresse_id) {
                this.user[column_adresse + "_id"] = adresse_id;
                this.onSubmit();
            }
        },
        getErrorForField(field, errors) {
            if (errors && errors[field]) {
                return errors[field].join(" ");
            }
        },
        editAdresse(column_adresse) {
            this.active_column_adresse = column_adresse;
            this.active_adresse_id = this.user[column_adresse + "_id"];
            this.dialogAdressesVisible = true;
        },
        delAdresse(column_adresse) {
            this.user[column_adresse + "_label"] = "";
            this.user[column_adresse + "_id"] = null;
            this.onSubmit();
        }
    }
};
</script>
